angular.module('impactx.cscontract').controller('CSContractConditionsDataCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    '$mdDialog',
    'ToolbarService',
    'PartialDialogsService',
    CSContractConditionsDataCtrl
]);

function CSContractConditionsDataCtrl($scope, dataGen, $routeParams, ToastService, BackService, $mdDialog, ToolbarService, PartialDialogsService) {
    var self = this;
    $scope.selectedPriceGroup = {};

    self.save = function ($event) {
        return dataGen.postAsForm($scope, {conditionsData: $scope.data}, "/cscontract/conditions/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.id, 'cscconditions', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    dataGen.getData($scope, {cscId: $routeParams.id}, "/cscontract/conditions/view").then(function () {
        defineButtons();
    });

    self.openPriceGroupConditionDialog = function (ev) {
        $mdDialog.show({
            controller: 'PriceGroupConditionDialogCtrl',
            controllerAs: 'priceGroupConditionDialogCtrl',
            templateUrl: 'modules/cscontract/templates/price-group-condition-dialog.tmpl.html',
            targetEvent: ev,
            clickOutsideToClose: false,
            locals: {
                trns: $scope.trns,
                priceGroupPopup: $scope.data.priceGroup,
                currentSelected: $scope.data.conditionRelationMaster ? $scope.data.conditionRelationMaster.assigned : $scope.data.conditionRelation.assigned,
                baseId: $scope.data.id,
                priceGroupSelected: $scope.selectedPriceGroup.priceGroup
            }
        }).then(function (response) {
            for (var i = 0; i < $scope.data.priceGroupConditionReplace.length; i++) {
                if ($scope.data.priceGroupConditionReplace[i].priceGroup === response.priceGroup) {
                    $scope.data.priceGroupConditionReplace[i].entries[response.replace.xOrder] = response.replace;
                    self.checkPriceGroupForChange($scope.data.priceGroupConditionReplace[i]);
                    break;
                }
            }
        });
    };

    self.deletePriceGroupItemAtIndex = function (priceGroupReplace, index) {
        priceGroupReplace.entries[index] = null;
        self.checkPriceGroupForChange(priceGroupReplace);
    };

    self.selectPriceGroup = function (priceGroup) {
        if ($scope.selectedPriceGroup === priceGroup) {
            $scope.selectedPriceGroup = {};
        }
        else {
            $scope.selectedPriceGroup = priceGroup;
        }
    };

    self.checkPriceGroupForChange = function (priceGroupReplace) {
        var oneOverridden = false;
        for (var i = 0; i < priceGroupReplace.entries.length; i++) {
            if (priceGroupReplace.entries[i] && priceGroupReplace.entries[i].id && priceGroupReplace.entries[i].id > 0) {
                oneOverridden = true;
                break;
            }
        }
        priceGroupReplace.hasOverriddenCondition = oneOverridden;
    };

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                condition: isEditable,
                params: {
                    form: $scope.dialogData
                }
            },
            {
                label: $scope.trns.priceGroupConditions,
                action: self.openPriceGroupConditionDialog,
                type: 'dialogaction',
                condition: canOpenPriceGroupConditionDialog
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }

    function isEditable() {
        return !$scope.data.readOnly;
    }

    function canOpenPriceGroupConditionDialog() {
        return $scope.data.canSetConditionsForPriceGroups && $scope.selectedPriceGroup.priceGroup;
    }
}